import React, { useContext, useState } from 'react';
import { AppBar, Toolbar, Typography, Button } from '@mui/material';
import { Link } from 'react-router-dom';
import { AuthContext } from './AuthContextProvider';
import { useNavigate } from 'react-router-dom';
import * as Constants from './Constants';

const HeaderAppBar = () => {
  const { user, logout } = useContext(AuthContext);
  const navigate = useNavigate();

  const handleLogout = () => {
    setActiveButton(null);
    logout();
    navigate('/login');
  };

  const [activeButton, setActiveButton] = useState(null);
  const handleButtonClick = (button) => {
    setActiveButton(button);
  };

  const getColor = (button) => {
    return activeButton === button ? 'secondary' : 'inherit';
  };

  const getMenuItems = () => {
    let menuItems = [];
    if (user?.loginRole === Constants.ROLE_SITE_ADMIN) {
      menuItems.push(<Button key='admins' component={Link} to="/siteAdmins"
        color={getColor('siteAdmins')}
        onClick={() => handleButtonClick('siteAdmins')}
      >Admins</Button>);
      menuItems.push(<Button key='sites' component={Link} to="/sites"
        color={getColor('sites')}
        onClick={() => handleButtonClick('sites')}
      >Sites</Button>);
      menuItems.push(<Button key='updateUser' component={Link} to="/updateUser"
        color={getColor('updateUser')}
        onClick={() => handleButtonClick('updateUser')}
      >Profile</Button>);
      menuItems.push(<Button key='siteEvents' component={Link} to="/siteEvents"
        color={getColor('siteEvents')}
        onClick={() => handleButtonClick('siteEvents')}
      >Schedule</Button>);
    } else if (user?.loginRole === Constants.ROLE_COMMUNITY_ADMIN) {
      menuItems.push(<Button key='today' component={Link} to="/today"
        color={getColor('today')}
        onClick={() => handleButtonClick('today')}
      >Today</Button>);
      menuItems.push(<Button key='scheduledEvents' component={Link} to="/scheduledEvents"
        color={getColor('scheduledEvents')}
        onClick={() => handleButtonClick('scheduledEvents')}
      >Schedule</Button>);
      menuItems.push(<Button key='motds' component={Link} to="/motds"
        color={getColor('motds')} 
        onClick={() => handleButtonClick('motds')}
      >MOTD</Button>);
      menuItems.push(<Button key='events' component={Link} to="/events"
        color={getColor('events')}
        onClick={() => handleButtonClick('events')}
      >Event</Button>);
      menuItems.push(<Button key='users' component={Link} to="/users"
        color={getColor('users')}
        onClick={() => handleButtonClick('users')}
      >User</Button>);
      menuItems.push(<Button key='groups' component={Link} to="/groups"
        color={getColor('groups')}
        onClick={() => handleButtonClick('groups')}
      >Group</Button>);
      menuItems.push(<Button key='photos' component={Link} to="/photos"
        color={getColor('photos')}
        onClick={() => handleButtonClick('photos')}
      >Photo</Button>);
      menuItems.push(<Button key='usage' component={Link} to="/usage"
        color={getColor('usage')}  
        onClick={() => handleButtonClick('usage')}
      >Usage</Button>);
    } else if (user?.loginRole === Constants.ROLE_FAMILY_MEMBER) {
      menuItems.push(<Button key='photos' component={Link} to="/photos"
        color={getColor('photos')}
        onClick={() => handleButtonClick('photos')}
      >Photo</Button>);
      menuItems.push(<Button key='updateUser' component={Link} to="/updateUser"
        color={getColor('updateUser')}
        onClick={() => handleButtonClick('updateUser')}
      >Profile</Button>);
    } else if (user?.loginRole === Constants.ROLE_PROGRAM_DIRECTOR) {
      menuItems.push(<Button key='today' component={Link} to="/today"
        color={getColor('today')}  
        onClick={() => handleButtonClick('today')}
      >Today</Button>);
      menuItems.push(<Button key='scheduledEvents' component={Link} to="/scheduledEvents"
        color={getColor('scheduledEvents')}
        onClick={() => handleButtonClick('scheduledEvents')}
      >Schedule</Button>);
      menuItems.push(<Button key='events' component={Link} to="/events"
        color={getColor('events')}
        onClick={() => handleButtonClick('events')}
      >Event</Button>);
    } else if (user?.loginRole === Constants.ROLE_INSTRUCTOR) {
      menuItems.push(<Button key='today' component={Link} to="/today"
        color={getColor('today')}
        onClick={() => handleButtonClick('today')}
      >Today</Button>);
    } 
    menuItems.push(<Button color='inherit' key='logout' onClick={handleLogout}>Logout</Button>);
    return menuItems;
  };

  const goHome = () => {
    setActiveButton(null);
    navigate('/home');
  };

  return (
    <AppBar className="AppBar" position="static">
      <Toolbar>
        <Typography variant="h6" component="div" sx={{ flexGrow: 1, cursor: "pointer"}} onClick={goHome}>
          TeleVisit Portal (v1.1)
        </Typography>
        {getMenuItems()}
      </Toolbar>
    </AppBar>
  );
};

export default HeaderAppBar;
